import { Box, List, Typography, ListItem, ListItemText } from "@mui/material";
import React from "react";

const Preview = ({ formik, currentStep, setCurrentStep }) => {
  return (
    <>
      <Box>
        <Typography variant="h4">Preview Details</Typography>

        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            marginTop: "20px",
          }}
        >
          <Box>
            <Typography variant="h6">Personal Information</Typography>
            <Box>
              <List>
                <ListItem>
                  <ListItemText primary={formik.values.full_name} />
                </ListItem>
                <ListItem>
                  <ListItemText primary={formik.values.email} />
                </ListItem>
                <ListItem>
                  <ListItemText primary={formik.values.phone} />
                </ListItem>
                <ListItem>
                  <ListItemText primary={formik.values.course_title} />
                </ListItem>
                <ListItem>
                  <ListItemText primary={formik.values.occupation} />
                </ListItem>
              </List>
            </Box>
          </Box>
          <Box>
            <Typography variant="h6">Acumen Text</Typography>
            <Box>
              <List>
                <ListItem>
                  <ListItemText primary={formik.values.motivation} />
                </ListItem>
              </List>
            </Box>
          </Box>
          <Box>
            <Typography variant="h6">Social Media link</Typography>
            <Box>
              <List>
                <ListItem>
                  <ListItemText primary={formik.values.linkedin_post_link} />
                </ListItem>
                <ListItem>
                  <ListItemText primary={formik.values.x_post_link} />
                </ListItem>
              </List>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Preview;
